/*
 * @Author: Liux- 1163777695@qq.com
 * @Date: 2024-05-10 11:37:18
 * @LastEditors: liux 1163777695@qq.com
 * @LastEditTime: 2025-03-10 10:08:53
 * @FilePath: /pc_mobel/src/utils/rem.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 基准大小
const baseSize = 16
    // 设置 rem 函数
function setRem() {
    // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。
    const scale = document.documentElement.clientWidth / 750
        // 设置页面根节点字体大小, 字体大小最小为12
    let fontSize = (baseSize * Math.min(scale, 2)) > 12 ? (baseSize * Math.min(scale, 2)) : 12
    document.documentElement.style.fontSize = fontSize + 'px'
}
//初始化
setRem()
    //改变窗口大小时重新设置 rem,这里最好加上节流
window.onresize = function() {
    setRem()
}